export default __webpack_public_path__ + "static/media/4.2.9f27fd74.jpg";